/* Request a width-capped WebP variant for images we serve ourselves.
   A 3 MB product PNG becomes a ~30-60 KB thumbnail. External URLs pass through. */
export const imgUrl = (url, w) => {
  if (!url || typeof url !== 'string') return url;
  if (!url.includes('/api/files/')) return url; // only our own served files can be resized
  if (/[?&]w=/.test(url)) return url;
  return `${url}${url.includes('?') ? '&' : '?'}w=${w}`;
};
